"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
function debounce(callback, delay, canceller) {
    if (delay === void 0) { delay = 100; }
    if (canceller === void 0) { canceller = function () { }; }
    var timerId;
    canceller(function () {
        window.clearTimeout(timerId);
    });
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (timerId !== undefined) {
            window.clearTimeout(timerId);
        }
        timerId = window.setTimeout(function () {
            callback.apply(void 0, args);
            timerId = undefined;
        }, delay);
    };
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map